import { IncognitoIcon } from "@remo-co/ui-core/src/icons/Incognito";
import { useI18n } from "i18n";
import { useCheckEventStatus } from "modules/event/hooks/useCheckEventStatus";
import { IEvent } from "modules/event/types";
import AuthButton from "modules/auth/authButtons/AuthButton";

interface Props {
  event: IEvent;
  onClick: () => void;
}

export const AnonymousLoginButton = ({ event, onClick }: Props) => {
  const { t } = useI18n(["auth"]);
  const { checkIsAllowedToJoinEvent } = useCheckEventStatus();

  const isAllowedToJoinEvent = checkIsAllowedToJoinEvent(event);

  if (!isAllowedToJoinEvent) {
    return null;
  }

  return (
    <AuthButton
      aria-label={t("auth:login.with.anonymous")}
      onClick={onClick}
      startAdornment={<IncognitoIcon />}
      color="blue"
      data-testid="anonymous-login-button"
    >
      {t("auth:login.with.anonymous")}
    </AuthButton>
  );
};
